export class ApiBizError {
  code: number;
  message: string;

  constructor(code: number, message: string) {
    this.code = code;
    this.message = message;
  }

  toString() {
    return this.message || 'unknown';
  }
}
